import cn from 'classnames';
import isEqual from 'lodash/isEqual';
import { useRouter, useSearchParams } from 'next/navigation';
import React, { useEffect, useState } from 'react';

import { useRoutesConfig } from '@/hooks/routes-config';
import { useFiltersQuery } from '@/hooks/used-cars/filters-query.hook';
import { useVehicles } from '@/hooks/used-cars/vehicles.hook';
import { stringifyQuery } from '@/services/QueryStringService';
import { getVehiclesWithFilters } from '@/services/used-cars/used-cars.service';

import styles from './mobile-filter.module.scss';

export const MobileFilter: React.FC<{
  title: string;
  handleVisibleChange?: (isVisible: boolean) => void;
  onClose?: () => void;
  onCloseMobileFilter?: () => void;
  children?: React.ReactNode;
  isVisible?: boolean;
}> = ({
  title,
  children,
  handleVisibleChange,
  onCloseMobileFilter,
  onClose = () => {
    return;
  },
}) => {
  const router = useRouter();
  const query = useSearchParams();
  const routes = useRoutesConfig();
  const { vehiclesMeta, setVehicles, setVehiclesMeta } = useVehicles();
  const { filtersQuery, activeCarType } = useFiltersQuery();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const applyFilters = () => {
    const meta = {
      ...vehiclesMeta,
      currentPage: 1,
    };

    if (
      query?.get('carType') &&
      !isEqual(stringifyQuery(filtersQuery), query.toString())
    ) {
      router.push(
        `${routes.searchResults.path}?${stringifyQuery(filtersQuery)}`,
      );
    }

    getVehiclesWithFilters(filtersQuery, meta, null, activeCarType).then(
      ({ vehicles, meta: newMeta }) => {
        setVehicles(vehicles);
        setVehiclesMeta({ ...meta, filterCount: newMeta.filter_count });
      },
    );

    handleVisibleChange && handleVisibleChange(false);
    if (onCloseMobileFilter) {
      onCloseMobileFilter();
    }
  };

  const handleClose = () => {
    onClose();
    handleVisibleChange && handleVisibleChange(false);
  };

  return (
    isMounted && (
      <div className={cn(styles.mobileFilter, 'mobileFilter')}>
        <div className={styles.mobileFilterHeader}>
          <p>{title}</p>
          <div className={styles.closeFilter} onClick={handleClose}></div>
        </div>
        {children}
        <div className={styles.mobileFilterFooter} onClick={applyFilters}>
          <p>Apply Filters ({Object.keys(filtersQuery)?.length ?? 0})</p>
        </div>
      </div>
    )
  );
};
